/**
 * Điểm vào ứng dụng - Application Entry Point
 *
 * Chức năng:
 * - Mount React app vào DOM
 * - Cấu hình BrowserRouter cho các chuyển hướng trang
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
